import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {GridSortItem} from '@mui/x-data-grid-pro';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';
import {Account, AccountFilters, AccountUI} from './account.model';

export interface AccountState {
  filters: AccountFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const accountStore = createStore(
  {name: 'account'},
  withProps<AccountState>({
    filters: {search: '', tableFilters: AccountFilters.initTableFilters(), hideExpired: true},
    sort: {
      field: '',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<Account>(),
  withUIEntities<AccountUI>(),
  withPagination(),
  withRequestsStatus()
);
